import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CTABanner = () => (
  <Box sx={{
    background: 'linear-gradient(135deg, #0f1535 0%, #233098 40%, #684df4 100%)',
    py: { xs: 8, md: 11 },
    position: 'relative',
    overflow: 'hidden',
  }}>
    <Box sx={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize: '28px 28px', pointerEvents: 'none' }} />
    <Box sx={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(104,77,244,0.2) 0%, transparent 65%)', top: -200, right: -200, pointerEvents: 'none' }} />
    <Container maxWidth="md" sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
      <Typography sx={{ color: '#c4b5fd', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 2, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
        Ready to Transform Your Institution?
      </Typography>
      <Typography variant="h2" sx={{ color: '#fff', fontWeight: 900, mb: 3, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '3rem' }, lineHeight: 1.2 }}>
        Double Your Admissions{' '}
        <Box component="span" sx={{ background: 'linear-gradient(90deg, #c4b5fd, #818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          This Season
        </Box>
      </Typography>
      <Typography sx={{ color: 'rgba(255,255,255,0.72)', fontSize: 17, mb: 5, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
        Join 500+ institutions who have transformed their admission process with SN Info Systems.<br />Free onboarding • No credit card • Results from day one.
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm="auto">
          <Button variant="contained" startIcon={<CalendarMonthIcon />} size="large"
            sx={{ bgcolor: '#684df4', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 16, boxShadow: '0 8px 32px rgba(104,77,244,0.5)', '&:hover': { bgcolor: '#5538d4', transform: 'translateY(-2px)' }, width: { xs: '100%', sm: 'auto' } }}>
            Book a Free Demo
          </Button>
        </Grid>
        <Grid item xs={12} sm="auto">
          <Button variant="outlined" startIcon={<PhoneIcon />} size="large"
            sx={{ borderColor: 'rgba(255,255,255,0.5)', color: '#fff', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 16, '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' }, width: { xs: '100%', sm: 'auto' } }}>
            Call: +91 97408 57368
          </Button>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default CTABanner;
